// AeroZeep Route Constants

export const ROUTES = {
  // Auth Routes
  LOGIN: '/login',
  SIGNUP: '/signup',
  ADMIN_LOGIN: '/admin/login',

  // Customer Routes
  HOME: '/',
  REFUND: '/refund',
  WALLET: '/wallet',
  SEARCH: '/search',
  HISTORY: '/history',

  // Admin Routes
  ADMIN: '/admin',
  ADMIN_REFUNDS: '/admin/refunds',
  ADMIN_INVOICES: '/admin/invoices',
  ADMIN_RECONCILIATION: '/admin/reconciliation',
  ADMIN_FRAUD: '/admin/fraud',

  // Regulator Routes
  REGULATOR: '/regulator',
  REGULATOR_COMPLIANCE: '/regulator/compliance',
} as const

export type RouteKey = keyof typeof ROUTES
export type RoutePath = (typeof ROUTES)[RouteKey]

// Navigation Items
export interface NavItem {
  label: string
  path: string
  icon?: string
}

export const CUSTOMER_NAV: NavItem[] = [
  { label: 'Home', path: ROUTES.HOME },
  { label: 'Get Refund', path: ROUTES.REFUND },
  { label: 'Wallet', path: ROUTES.WALLET },
  { label: 'Book Flight', path: ROUTES.SEARCH },
  { label: 'History', path: ROUTES.HISTORY },
]

export const ADMIN_NAV: NavItem[] = [
  { label: 'Dashboard', path: ROUTES.ADMIN },
  { label: 'Refunds', path: ROUTES.ADMIN_REFUNDS },
  { label: 'Invoices', path: ROUTES.ADMIN_INVOICES },
  { label: 'Reconciliation', path: ROUTES.ADMIN_RECONCILIATION },
  { label: 'Fraud Detection', path: ROUTES.ADMIN_FRAUD },
]

export const REGULATOR_NAV: NavItem[] = [
  { label: 'Audit Trail', path: ROUTES.REGULATOR },
  { label: 'Compliance', path: ROUTES.REGULATOR_COMPLIANCE },
]
